// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.btn {
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: bold;
}

.btn-outline-primary {
    border: 1px solid #dbc700;
    color: black;
    background: transparent;
}

.btn-outline-primary:hover,
.btn-outline-primary:active {
    background: #dbc700;
    color: white;
}

.w-full {
    width: 100%;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRlYW0tZmlsdGVyLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixtQkFBbUI7SUFDbkIsaUJBQWlCO0FBQ3JCOztBQUVBO0lBQ0kseUJBQXlCO0lBQ3pCLFlBQVk7SUFDWix1QkFBdUI7QUFDM0I7O0FBRUE7O0lBRUksbUJBQW1CO0lBQ25CLFlBQVk7QUFDaEI7O0FBRUE7SUFDSSxXQUFXO0FBQ2YiLCJmaWxlIjoidGVhbS1maWx0ZXIuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIlxuXG4uYnRuIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDJyZW07XG4gICAgcGFkZGluZy1yaWdodDogMnJlbTtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbn1cblxuLmJ0bi1vdXRsaW5lLXByaW1hcnkge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICNkYmM3MDA7XG4gICAgY29sb3I6IGJsYWNrO1xuICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xufVxuXG4uYnRuLW91dGxpbmUtcHJpbWFyeTpob3Zlcixcbi5idG4tb3V0bGluZS1wcmltYXJ5OmFjdGl2ZSB7XG4gICAgYmFja2dyb3VuZDogI2RiYzcwMDtcbiAgICBjb2xvcjogd2hpdGU7XG59XG5cbi53LWZ1bGwge1xuICAgIHdpZHRoOiAxMDAlO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/components/team-filter/team-filter.component.css"],"names":[],"mappings":";;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,g4BAAg4B","sourcesContent":["\n\n.btn {\n    padding-left: 2rem;\n    padding-right: 2rem;\n    font-weight: bold;\n}\n\n.btn-outline-primary {\n    border: 1px solid #dbc700;\n    color: black;\n    background: transparent;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:active {\n    background: #dbc700;\n    color: white;\n}\n\n.w-full {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
